import { Skeleton } from '@shared/components/shadcn';
import { UnsubscribePageContainer } from '..';

/**
 * Component to display a loading screen when the unsubscribe data is being fetched
 * @returns A component to display a loading screen when the unsubscribe data is being fetched
 */
function UnsubscribeScreenLoading() {
  return (
    <UnsubscribePageContainer>
      <div className="flex flex-col gap-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="w-full h-14.5 rounded-md" />
        ))}
      </div>
      <Skeleton className="w-full h-10 rounded-full" />
      <Skeleton className="w-60 h-6 rounded-md mx-auto" />
    </UnsubscribePageContainer>
  );
}

export { UnsubscribeScreenLoading };
